import Page from "../../atoms/page";

const Builder = (props) => {
	
	return (
		<Page title="System Model" padding={0}>
		</Page>
	);
};

export default Builder;
